import { Button, Divider, Ellipsis, Toast } from "antd-mobile";
import dayjs from "dayjs";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";
import vars from "../../assets/styles/_variables.scss";
import {
  CurrencyChanger,
  CustomDialog,
  CustomPopup,
  CustomTable,
  CustomTabs,
} from "../../components";

import { useAuth } from "../../context/AuthContext";
import { useGetUserInfo } from "../../hooks/userinfo.hooks";
import { moneyFormat } from "../../plugins/numberFormat";
import { envChangeType, envType, getCurrency, getUserCurrency } from "../../plugins/utils";
import extraBonusStatus from "./enumerations";
import {
  useApplyActivePromotion,
  useGetAgentPromoActiveSetting,
  useGetPromoActiveUser,
  useGetPromoExtraBonus,
  useReceiveExtraBonus,
} from "./hooks/promo.hook";
import styles from "./style.module.scss";
import "./style.scss";

const userCurrency = getUserCurrency();
const nowCurrency = getCurrency();

export const buildSubDomain = () => {
  const url = new URL(window.location.href);
  url.hostname = url.hostname.replace(/^[^.]+/, "www");
  return url.origin;
};

const Promote = () => {
  const { t } = useTranslation();
  const { lang } = useAuth();

  const { data: currentUser, isLoading, error, isError } = useGetUserInfo({});
  const mainUrl = envChangeType("REACT_APP_SPECIAL_DIRECT", envType.BOOLEAN)
    ? buildSubDomain()
    : currentUser?.main_url;

  const {
    data: promoActiveUser,
    isLoading: isLoadingPromo,
    error: errorPromo,
    isError: isErrorPromo,
  } = useGetPromoActiveUser({ stale_time: 0 });
  const { data: extraBonusRecord } = useGetPromoExtraBonus({ stale_time: 0 });

  const { data: promoActiveSetting, error: promoError } = useGetAgentPromoActiveSetting({});

  const { mutate: applyActivePromotion } = useApplyActivePromotion();
  const { mutate: receiveExtraBonus } = useReceiveExtraBonus();

  const [openDetailDrawer, setOpenDetailDrawer] = useState(false);
  const [activeTab, setActiveTab] = useState("promotion_bonus");
  const [tabItems, setTabItems] = useState([]);

  const [promoCurrency, setPromoCurrency] = useState(nowCurrency);
  const [showCurrencyChanger, setShowCurrencyChanger] = useState(false);

  const copyText = (text, successMessageContent) => {
    if (!text) return;
    // navigator.clipboard.writeText(text);
    const selectGroup = document.getElementById("menu-copy-group");
    const tempArea = document.createElement("textarea");
    selectGroup?.appendChild(tempArea);
    tempArea.innerText = text;
    tempArea.select();
    document.execCommand("Copy");
    selectGroup?.removeChild(tempArea);
    Toast.show({ icon: "success", content: successMessageContent });
  };

  const onOpenDetail = () => {
    setOpenDetailDrawer(true);
  };

  const handleReceiveReward = async (is_blacklist) => {
    if (is_blacklist === true) {
      CustomDialog({
        type: "alert",
        dialogProps: {
          header: t("promotion.blacklisted.title"),
          destroyOnClose: true,
          content: <p>{t("promotion.blacklisted.desc")}</p>,
          onConfirm: async () => {},
          confirmText: <>{t("mobile.normal.understand")}</>,
        },
      });
    } else {
      await applyActivePromotion(
        {},
        {
          onSuccess: () => {},
          onError: (error) => {},
        },
      );
    }
  };

  const handleReceiveExtraBonus = async (data) => {
    await receiveExtraBonus(
      { level: data.level },
      {
        onSuccess: () => {},
        onError: (error) => {},
      },
    );
  };

  const renderFunctionButton = (data) => {
    if (data.total_reward_available > 0) {
      return (
        <div className={styles.buttonBlue} onClick={() => handleReceiveReward(data.is_blacklist)}>
          {t("normal.receive")}
        </div>
      );
    }
    return <div className={styles.buttonDisabled}>{t("normal.receive")}</div>;
  };

  const renderButtonText = (data) => {
    if (data.status === extraBonusStatus.AVAILABLE) {
      return t("normal.receiveNow");
    } else if (data.status === extraBonusStatus.RECEIVED) {
      return t("tradeRecord.receive.received");
    } else {
      return t("normal.receiveNow");
    }
  };

  const columns_requirement = [
    {
      title: t("promotion.active.levels"),
      width: 10,
      align: "center",
      render: (_, record) => t(`promotion.active.levels.${record.level}`),
    },

    {
      title: t("promotion.active.amountreceived"),
      width: 10,
      align: "center",
      dataIndex: "bonus",
      render: (text, record, index) => t(`global.currency.${userCurrency}`) + moneyFormat(text),
    },
  ];
  const columns_current_user = [
    {
      title: t("promotion.active.totalmember"),
      width: 50,
      align: "center",
      dataIndex: "active_user_count",
    },

    {
      title: t("promotion.active.unclaimedreward"),
      width: 50,
      align: "center",
      dataIndex: "not_receive_user_count",
    },
    {
      title: t("promotion.active.amountreceived"),
      width: 50,
      align: "center",
      dataIndex: "total_reward_available",
    },
    {
      title: t("normal.operation"),
      width: 50,
      align: "center",
      dataIndex: "bonus",
      render: (text, record, index) => <>{renderFunctionButton(record)}</>,
    },
  ];
  // const columns_extra_bonus = [
  //   {
  //     title: t("promote.total.activeUsers"),
  //     width: 50,
  //     align: "center",
  //     dataIndex: "active_user",
  //     render: (text, record, index) => text?.toLocaleString(),
  //   },

  //   {
  //     title: t("promote.extraBonus"),
  //     width: 50,
  //     align: "center",
  //     dataIndex: "bonus_amount",
  //     render: (text, record, index) => t(`global.currency.${userCurrency}`) + moneyFormat(text),
  //   },
  //   {
  //     title: t("normal.operation"),
  //     width: 50,
  //     align: "center",
  //     dataIndex: "bonus",
  //     render: (text, record, index) => <>{renderExtraBonusFunctionButton(record)}</>,
  //   },
  // ];

  const downloadCanvas = () => {
    const svg_root = document.getElementById("invite-canvas");
    const image = svg_root?.toDataURL("image/png").replace("image/png", "image/octet-stream"); //Convert image to 'octet-stream' (Just a download, really)
    const a = document.createElement("a");
    const e = new MouseEvent("click");
    a.download = `invite${dayjs().format("YYYYMMDDHHmmSS")}.png`;
    a.href = image;
    a.dispatchEvent(e);
  };

  const renderRightContent = (
    <div onClick={downloadCanvas} className={styles.button}>
      {t("mobile.normal.download")}
    </div>
  );

  const renderPromoActiveSetting = () => {
    if (!promoActiveSetting) return null;
    const currentCurrencyActiveSetting = promoActiveSetting[promoCurrency];
    return (
      <ul className={styles.promoSettingList}>
        {Object.keys(currentCurrencyActiveSetting).map((key) => {
          const value = JSON.parse(currentCurrencyActiveSetting[key].value);
          if (value.is_open === 1) {
            return (
              <li>{`${t(`promo.active.${key}`)} ${t(`global.currency.${promoCurrency}`)} ${
                value.req_amount
              }`}</li>
            );
          } else {
            return null;
          }
        })}
      </ul>
    );
  };

  const renderExtraPromotion = useCallback(() => {
    if (!extraBonusRecord || extraBonusRecord?.length <= 0) return;
    return (
      <div className={`${styles.row} ${styles.column}`}>
        <div className={`${styles.subContainer}`}>
          <div className={styles.titleActiveSubContainer}>
            <div className={styles.descTitleHint}>
              {t([
                `promote.extraBonus.title.hint.${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}`,
                "promote.extraBonus.title.hint",
              ])}
            </div>
          </div>
          <p className={styles.descTitle}>{t("promotion.active.milestone")}</p>
          <div className={styles.cardContainer}>
            {/* <CustomTable
              className={"promote-table"}
              columns={columns_extra_bonus}
              dataSource={extraBonusRecord}
              showInifineScroll={false}
              scrollX={Math.min(window.innerWidth - 32, vars.maxWidthInPc - 32)}
            /> */}
            {/* status 0可領取 1已領取 null不可領取 */}
            {extraBonusRecord.map((item) => (
              <div
                key={item.id}
                className={`${styles.card} ${
                  item.status === extraBonusStatus.UNAVAILABLE ? styles.disable : ""
                }`}
              >
                <div className={styles.cardHeader}>
                  <div className={styles.cardTitle}>{t("promote.total.activeUsers")}</div>
                  <div className={styles.cardValue}>{item.active_user}</div>
                </div>
                <div className={styles.cardContent}>
                  <div>
                    <div className={styles.cardTitle}>{`${t(
                      "promotion.active.amountreceived",
                    )}（${userCurrency}）`}</div>
                    <div className={styles.cardValue}>{moneyFormat(item.bonus_amount)}</div>
                  </div>
                </div>
                <img
                  src={require("./images/coin_active.png")}
                  alt="coin_active"
                  className={`${styles.coin}`}
                />
                <Button
                  className={`${styles.cardButton} ${
                    item.status !== extraBonusStatus.AVAILABLE ? styles.disabled : ""
                  }`}
                  disabled={item.status !== extraBonusStatus.AVAILABLE}
                  onClick={() => handleReceiveExtraBonus(item)}
                >
                  {renderButtonText(item)}
                </Button>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }, [tabItems, extraBonusRecord]);

  const renderActiveUserPromotion = useCallback(() => {
    if (!promoActiveUser || !promoActiveUser.requirement) return;
    return (
      <div className={`${styles.row} ${styles.column}`}>
        <div className={`${styles.subContainer}`}>
          <div className={styles.titleActiveSubContainer}>
            <div className={styles.descTitleHint}>
              {promoActiveUser
                ? t("mobile.normal.lastUpdate", { time: promoActiveUser?.last_update_at })
                : ""}
            </div>
            <div className={styles.descTitleHint}>{t("promotion.active.promolist.hint")}</div>
          </div>
          <p className={styles.descTitle}>{t("promotion.active.promolist.title")}</p>
          <div>
            <CustomTable
              className={"promote-table"}
              columns={columns_requirement}
              dataSource={promoActiveUser?.requirement}
              showInifineScroll={false}
              scrollX={Math.min(window.innerWidth - 32, vars.maxWidthInPc - 32)}
            />
          </div>
        </div>
        <div className={`${styles.subContainer}`}>
          <p className={styles.descTitle}>{t("promotion.active.currentrecord")}</p>
          <div>
            <CustomTable
              className={"promote-table"}
              columns={columns_current_user}
              dataSource={promoActiveUser?.current_count}
              showInifineScroll={false}
              scrollX={Math.min(window.innerWidth - 32, vars.maxWidthInPc - 32)}
            />
          </div>
        </div>
      </div>
    );
  }, [tabItems, promoActiveUser]);

  const tabPromoBonus = {
    key: "promotion_bonus",
    title: t("promotion.active.promolist.title"),
    component: renderActiveUserPromotion(),
    destroyOnClose: true,
  };

  const tabMilestone = {
    key: "promotion_milestone",
    title: t("promotion.active.milestone"),
    component: renderExtraPromotion(),
    destroyOnClose: true,
  };

  const onTabChange = (key) => {
    setActiveTab(key);
  };

  useEffect(() => {
    const tabs = [];
    console.debug("promoActiveUser", promoActiveUser);
    console.debug("extraBonusRecord", extraBonusRecord);
    if (promoActiveUser && promoActiveUser.requirement) {
      tabs.push(tabPromoBonus);
    }
    if (extraBonusRecord && extraBonusRecord?.length > 0) {
      tabs.push(tabMilestone);
    }
    setTabItems(tabs);
    if (tabs.length > 0) {
      setActiveTab(tabs[0].key);
    }
  }, [promoActiveUser, extraBonusRecord]);

  return (
    <div className={styles.container}>
      <div id="menu-copy-group" />
      <div className={`${styles.row} ${styles.space}`}>
        <div className={styles.title}>{t("header.menu.inviteCodeDownload")}</div>
        <div onClick={onOpenDetail} className={styles.button}>
          {t("normal.show")}
        </div>
      </div>
      <div className={`${styles.row}`}>
        <div className={styles.titleContainer}>
          <div className={styles.title}>{t("header.menu.inviteCode")}</div>
          <div className={styles.desc}>{currentUser?.invite_code}</div>
        </div>
        <div
          onClick={() => {
            copyText(currentUser?.invite_code, t("normal.copy.success"));
          }}
          className={styles.button}
        >
          {t("mobile.normal.copy")}
        </div>
      </div>
      <Divider className={styles.dividerSmall} />
      <div className={`${styles.row}`}>
        <div className={styles.titleContainer}>
          <div className={styles.title}>{t("header.menu.inviteLink")}</div>
          <Ellipsis
            direction="end"
            content={`${mainUrl}/?invite=${currentUser?.invite_code}`}
            className={styles.desc}
          />
        </div>
        <div
          onClick={() => {
            copyText(`${mainUrl}/?invite=${currentUser?.invite_code}`, t("normal.copy.success"));
          }}
          className={styles.button}
        >
          {t("mobile.normal.copy")}
        </div>
      </div>
      <div className={`${styles.row} ${styles.column} ${styles.noBackground}`}>
        <div className={styles.currencyContainer}>
          <div
            onClick={() => {
              setShowCurrencyChanger(true);
            }}
          >
            {t("navBar.currency")}
            <span style={{ color: "var(--nav-topbar-link)" }}>{promoCurrency}</span>
          </div>
        </div>
        <div className={styles.activeRequirementDesc}>{`${t(
          "promotion.active.promo.req.desc",
        )}`}</div>
        <div className={styles.activeRequirementDesc}>{`${t(
          "promotion.active.promo.req.desc2",
        )}`}</div>
        {renderPromoActiveSetting()}
        <div className={styles.activeRequirementDesc}>{`${t(
          "promotion.active.promo.req.desc3",
        )}`}</div>
      </div>
      {(!promoActiveUser || !promoActiveUser?.requirement) && extraBonusRecord?.length <= 0 ? (
        ""
      ) : (
        <div className={`${styles.row} ${styles.column} ${styles.noPadding}`}>
          <div className={styles.tabContainer}>
            <CustomTabs
              activeKey={activeTab}
              onTabChange={onTabChange}
              tabItems={tabItems}
              stretch={false}
              customTabContainerStyle={styles.customTab}
            />
          </div>
        </div>
      )}
      <CustomPopup
        visible={openDetailDrawer}
        right={renderRightContent}
        onClose={() => {
          setOpenDetailDrawer(false);
        }}
        title={t("header.menu.inviteCodeDownload")}
        destroyOnClose={true}
      >
        <div
          style={{
            background: `no-repeat top url('images/promote/${
              lang === "zh" ? lang : "en"
            }/qr_bg.jpg')`,
            backgroundSize: "cover",
          }}
          className={styles.detailBackground}
        >
          <div className={styles.qr}>
            <QRCode value={`${mainUrl}/?invite=${currentUser?.invite_code}`} size={230} />
          </div>
        </div>
      </CustomPopup>
      <CurrencyChanger
        visible={showCurrencyChanger}
        onClose={() => {
          setShowCurrencyChanger(false);
        }}
        customOnChangeEvent={(val) => {
          setPromoCurrency(val);
          setShowCurrencyChanger(false);
        }}
      />
    </div>
  );
};
export default Promote;
